export const sortByState = fields => {
  return [...fields].sort((a, b) => {
    return a.estado?.label?.localeCompare(b.estado?.label);
  });
};
